import { Alert, AlertDescription } from '@xiltrion/ui/alert';
import { Button } from '@xiltrion/ui/button';
import { Icono } from '@xiltrion/ui/icono';
import { useSession } from '@/app/session';

/**
 * Con la suite conectada, la ficha, la marca y el calendario de la entidad los administra su administrador en la suite
 * (GUIA-AGENTES §3.11 de la suite): aquí solo se ven. Devuelve el enlace a la entidad en la suite, o null desacoplado.
 */
export function useSuiteManagesEntity(): { url: string | null } | null {
  const { me } = useSession();
  return me?.suite.managesEntity ? { url: me.suite.url } : null;
}

/** El aviso de solo lectura: qué se cambia en la suite y, si hay, el enlace para ir. */
export function SuiteManagedAlert({ children, url }: { children: React.ReactNode; url?: string | null }) {
  return (
    <Alert variant="info">
      <Icono nombre="mdi:apps" />
      <AlertDescription>
        <span>{children}</span>
        {url && <Button asChild size="sm" variant="outline" className="mt-2 w-fit"><a href={url} target="_blank" rel="noreferrer"><Icono nombre="mdi:open-in-new" /> Abrir en la suite</a></Button>}
      </AlertDescription>
    </Alert>
  );
}
